export default "__VITE_ASSET__BlJ365xw__"